import { render, staticRenderFns } from "./CreditLimit.vue?vue&type=template&id=749b210d"
import script from "./CreditLimit.vue?vue&type=script&lang=ts"
export * from "./CreditLimit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports